import { render, staticRenderFns } from "./ruleConfig.vue?vue&type=template&id=d579e65e"
import script from "./ruleConfig.vue?vue&type=script&lang=js"
export * from "./ruleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports